import styled from 'styled-components'
import { Box } from 'styling/GlobalStyles'

export const StatusCircle = styled.div`
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.6rem;
  background: ${(props) => props.color};
  border-radius: 50%;
`

export const ImageModalFrame = styled.div`
  max-height: 30vh;
  max-width: 40vw;
  height: 30vh;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    object-fit: contain;
  }
`

export const ContractInputWrapper = styled.div`
  
  display: flex;
  flex-direction:column;
  gap:1rem;
  width:100%;
  
  @media (max-width: 500px) {
  
    width:100%;
  }

`

export const ContractShiftsContainer = styled.div`
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  gap:1rem;
  margin-top: 1rem;
`

export const ShiftListItem = styled.div`
  ${props => props.theme.content};
  border: 1px solid #ffffff20;
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

`

export const WelfareConatainer = styled.div`
    display: flex;
    width: 100%;
    gap: 1rem;

  @media (max-width: 1300px) {
  
    flex-direction:column;
  
  }


`

export const EmployeeCountCard = styled(Box) <{ color?: string }>`
  
  height: 100px;
  padding: 1rem;
  display: flex;
  gap: 12px;
  width: 100%;
  border-left:1.5px solid ${props => props.color ? props.color : props.theme.primary};
  border-radius: 12px;
  align-items: center;


`